export default "__VITE_ASSET__DSPjnI_X__"